module.exports = __webpack_public_path__ + "img/SSWS_Bronze_sword.481134f8.png";